import { AxiosResponse } from 'axios';
import httpClient from '../base/httpClient';
import { ApiResponse } from '../../types/common';
import { AuthResponse, LoginRequest, User } from '../../types/auth';

class AuthService {
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    const response: AxiosResponse<AuthResponse> = await httpClient
      .getClient()
      .post('/auth/login', credentials);

    httpClient.setToken(response.data.token);
    return response.data;
  }

  async logout(): Promise<void> {
    try {
      await httpClient.getClient().post('/auth/logout');
    } finally {
      httpClient.clearToken();
    }
  }

  async getProfile(): Promise<ApiResponse<User>> {
    const response: AxiosResponse<ApiResponse<User>> = await httpClient
      .getClient()
      .get('/auth/me');
    return response.data;
  }

  async changePassword(oldPassword: string, newPassword: string): Promise<ApiResponse<any>> {
    const response = await httpClient.getClient().post('/auth/change-password', {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirmation: newPassword,
    });
    return response.data;
  }

  getToken(): string | null {
    return httpClient.getToken();
  }

  isAuthenticated(): boolean {
    return !!httpClient.getToken();
  }
}

export const authService = new AuthService();
export default authService;